import { generateHash } from '../logging/hash-generator';
export function correlationIdHeader() {
    return {
        correlationId: generateHash(),
    };
}
